import { type ReactNode } from 'react';
import { ModalOverlay, ModalWrapper, type ModalProps } from '~/shared/components/modal/Modal';
import { Form, type FormProps } from '~/shared/forms/Form';
import { FooterButtonContainer } from './buttons/FooterButtonContainer';
import { CancelButton } from './buttons/CancelButton';
import { FormSubmitButton, type FormSubmitButtonProps } from './buttons/FormSubmitButton';
import type { FormHelpers } from './types';

export interface FormModalProps extends Omit<ModalProps, 'children'>, Omit<FormProps, 'className'> {
	submitButton?: (formHelpers: FormHelpers) => ReactNode;
	disableErrorDisplay?: boolean;
	submitButtonProps?: Omit<FormSubmitButtonProps, 'onSubmit'>;
	modalClassName?: string;
}

export function FormModal(props: FormModalProps) {
	return (
		<ModalOverlay {...props}>
			<Form {...props} className="h-full">
				{formHelpers => (
					<ModalWrapper
						{...props}
						className={props.modalClassName}
						footer={
							<FooterButtonContainer>
								<CancelButton onCancel={props.closeModal} />
								{!props.submitButton || !props.submitButton(formHelpers) ? (
									<FormSubmitButton {...props.submitButtonProps} />
								) : (
									props.submitButton(formHelpers)
								)}
							</FooterButtonContainer>
						}
					>
						<div className="grow overflow-y-auto">
							{formHelpers.displayErrorElement && props.disableErrorDisplay !== true && formHelpers.errorElement}
							{typeof props.children === 'function' ? props.children(formHelpers) : props.children}
						</div>
					</ModalWrapper>
				)}
			</Form>
		</ModalOverlay>
	);
}
